export const FileContent = ({ resource }) => {
  return false
}
